namespace $ {
	
	export enum $giper_baza_slot_kind {
		
		/** Free Unit Slot */
		free = 0,
		
		/** Land header for the following parts. */
		land = 76, // L
		
		/** Unit of data. */
		sand = 252,
		
		/** Rights/Keys sharing. */
		gift = 253,
		
		/** Sign for hash list. */
		seal = 254,
		
		/** Public key. */
		pass = 255,
		
	}
	
}
